import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import QuickNews from "@/pages/home/components/QuickNews";
import UpdateFeed from "@/pages/home/components/UpdateFeed";
import CharacterSpotlight from "@/pages/home/components/CharacterSpotlight";
import CommunityHot from "@/pages/home/components/CommunityHot";
import Collections from "@/pages/home/components/Collections";

const quickLinks = [
  { label: "动漫资讯", to: "/news", icon: "ri-newspaper-line", desc: "新番前瞻与深度解读" },
  { label: "动画更新", to: "/updates", icon: "ri-tv-2-line", desc: "追番日历与集数速递" },
  { label: "角色介绍", to: "/characters", icon: "ri-user-star-line", desc: "首字母索引角色档案" },
  { label: "动漫社区", to: "/community", icon: "ri-chat-smile-2-line", desc: "话题讨论与推荐交流" },
];

export default function Home() {
  return (
    <div>
      <HeroCarousel />

      <section className="page-wrap mt-10">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-2xl">
            <h1 className="text-2xl font-extrabold text-foreground-950 md:text-3xl">
              漫蛙2 · 一站式动漫资讯平台
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              聚合最新动漫资讯、动画更新速递、角色档案与粉丝社区交流。无论你是追番党还是补番党，都能在这里找到想看的内容。
            </p>
          </div>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-3 md:gap-4 lg:grid-cols-4">
          {quickLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="group flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                <i className={`${link.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <span className="min-w-0">
                <span className="block text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
                  {link.label}
                </span>
                <span className="mt-0.5 block text-xs text-foreground-500">{link.desc}</span>
              </span>
            </Link>
          ))}
        </div>
      </section>

      <QuickNews />
      <UpdateFeed />
      <CharacterSpotlight />

      <section className="page-wrap mt-14 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <CommunityHot />
        <Collections />
      </section>

      <section className="mt-14 bg-secondary-900 py-14">
        <div className="page-wrap flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center">
          <div className="max-w-2xl">
            <h2 className="text-xl font-bold text-background-50 md:text-2xl">加入漫蛙2社区，和同好一起聊动漫</h2>
            <p className="mt-3 text-sm leading-relaxed text-background-300 md:text-base">
              分享你的追番清单、参与新番讨论、安利冷门佳作。每一个认真的观点，都会遇到同样认真的人。
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/community"
              className="inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-chat-smile-2-line"></i>
              进入社区
            </Link>
            <Link
              to="/help"
              className="inline-flex whitespace-nowrap items-center gap-1.5 rounded-md border border-secondary-700 px-5 py-2.5 text-sm font-medium text-background-100 transition-colors hover:border-primary-400 hover:text-primary-300"
            >
              了解使用指引
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}